import styled from 'styled-components';

export const StyledProductCtaWrapper = styled.div<{ $hideShadow?: boolean }>`
  display: flex;
  justify-content: space-around;
  gap: 1rem;
  padding: 1rem;
  box-shadow: ${p => (p.$hideShadow ? '' : p.theme.token('drop-shadow-bottom-nav'))};
  z-index: 1;
`;
